import { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { EditorProps } from '../types';
import 'grapesjs/dist/css/grapes.min.css';
import grapesjs, { Editor } from 'grapesjs';

const getFullHtml = (editor: Editor) => {
  const html = editor.getHtml();
  const css = editor.getCss();

  return `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8" />
    <style>
${css}
    </style>
  </head>
${html}
</html>
`.trim();
};

const HTMLEditor = ({ ref, value, colormode, mime }: EditorProps) => {
  const htmlRef = useRef<HTMLDivElement>(null);
  const initRef = useRef<boolean>(false);
  const editorRef = useRef<Editor | null>(null);
  const [mounted, setMounted] = useState(false);

  useImperativeHandle(
    ref,
    () => {
      return {
        getValue: async () => {
          return {
            raw: getFullHtml(editorRef.current!),
          };
        },
        hasError: async () => {
          return false;
        },
      };
    },
    [mounted]
  );

  useEffect(() => {
    if (initRef.current || !htmlRef.current) {
      return;
    }
    editorRef.current = grapesjs.init({
      container: htmlRef.current,
      storageManager: false,
      height: '100%'
    });
    editorRef.current.setComponents(value);
    initRef.current = true;
    setMounted(true);
  }, []);

  return (
    <div
      style={{
        maxWidth: '100%',
        width: '100%',
        maxHeight: '100vh',
        height: '100%',
      }}
      ref={htmlRef}
    ></div>
  );
};

export default HTMLEditor;
